module.exports = __webpack_public_path__ + "img/solution-data-logo1.679b3790.png";